var _a, _b;
import { PaymentFrequency, PaymentMethod } from '../../core/reducers/financialCalculators';
export var tabType = {
    finance: 'finance',
    lease: 'lease',
    rebate: 'rebate',
};
export var tabTypeToPaymentMethodMap = (_a = {},
    _a[tabType.finance] = PaymentMethod.finance,
    _a[tabType.lease] = PaymentMethod.lease,
    _a[tabType.rebate] = PaymentMethod.cash,
    _a);
export var variants = {
    variant1: 'variant1',
    variant2: 'variant2',
    variant3: 'variant3',
    variant4: 'variant4',
    variant5: 'variant5',
};
export var variant1 = variants.variant1, variant2 = variants.variant2, variant3 = variants.variant3, variant4 = variants.variant4, variant5 = variants.variant5;
/*
Stackable offers:

Customer Incentive Dollars
Trading Dollars
AFS Loyalty Dollars
Cash or Maintenance Package
CRM Dollars
Lease Bonus
Finance Bonus
Special Sales Event (3-day sale)

Non-stackable offers:
Non-Stackable Trading Dollar (NSTD)
Lease NSTD
Finance NSTD
*/
export var incentiveOfferName = {
    customerIncentiveDollars: 'Customer Incentive Dollars',
    customerCashRebate: 'Customer Cash Rebate',
    tradingDollars: 'Trading Dollars',
    afsLoyaltyDollars: 'AFS Loyalty Dollars',
    cashOrMaintenancePackage: 'Cash or Maintenance Package',
    crmDollars: 'CRM Dollars',
    leaseBonus: 'Lease Bonus',
    financeBonus: 'Finance Bonus',
    specialSalesEvent: 'Special Sales Event (3-day sale)',
    nonStackableTradingDollar: 'Non Stackable Trading Dollar (NSTD)',
    leaseNSTD: 'Lease NSTD',
    financeNSTD: 'Finance NSTD',
};
export var sortByOption = {
    sellingPriceLowest: 'selling-price-lowest',
    sellingPriceHighest: 'selling-price-highest',
    modelYearLowest: 'model-year-lowest',
    modelYearHighest: 'model-year-highest',
    paymentLowest: 'payment-lowest',
    paymentHighest: 'payment-highest',
};
export var sortPrimaryKey = {
    price: 'price',
    modelYear: 'modelYear',
    payment: 'payment',
};
export var sortDirection = {
    ascending: 'asc',
    descending: 'desc',
};
export var sortConfig = (_b = {},
    _b[sortByOption.sellingPriceLowest] = {
        sortByKey: sortPrimaryKey.price,
        direction: sortDirection.ascending,
    },
    _b[sortByOption.sellingPriceHighest] = {
        sortByKey: sortPrimaryKey.price,
        direction: sortDirection.descending,
    },
    _b[sortByOption.modelYearLowest] = {
        sortByKey: sortPrimaryKey.modelYear,
        direction: sortDirection.ascending,
    },
    _b[sortByOption.modelYearHighest] = {
        sortByKey: sortPrimaryKey.modelYear,
        direction: sortDirection.descending,
    },
    _b[sortByOption.paymentLowest] = {
        sortByKey: sortPrimaryKey.payment,
        direction: sortDirection.ascending,
    },
    _b[sortByOption.paymentHighest] = {
        sortByKey: sortPrimaryKey.payment,
        direction: sortDirection.descending,
    },
    _b);
export { PaymentFrequency, PaymentMethod };
